module.exports = __webpack_public_path__ + "img/logo_edu_login.45b1176a.png";